import axios from "axios";
import Vue from "vue";
import utils from "../../utils";
import { DateTime } from "luxon";

const state = {
  /**
   *  Poslední parametry pro získání knihy jízd
   */
  query: null,
  /**
   * Vybrané vozidlo
   */
  vehicle: null,
  /**
   * Období počátek.
   * Období je většinou jeden den.
   */
  periodFrom: null,
  /**
   * Období konec.
   * Období je většinou jeden den.
   */
  periodTo: null,
  /**
   * Jízdy pro vybarné obodbí
   */
  rides: [],
  /**
   * Aktuálně vybraná jízda
   */
  ride: null,
  /**
   * Pozice pro vybarno jízdu
   */
  locations: [],
  /**
   * Pozice aktuální jízdy
   */
  fetching: false,
  fetched: null,
  running: null
};

const getters = {
  canPrevRide: state => {
    if (state.rides === null || state.rides.length === 0)
      return false;

    if (state.ride === null)
      return true;
    else {
      let index = state.rides.findIndex(x => x.fromTimestamp === state.ride.fromTimestamp);
      return index > 0;
    }
  },

  canNextRide: state => {
    if (state.rides === null || state.rides.length === 0)
      return false;

    if (state.ride === null)
      return true;
    else {
      let index = state.rides.findIndex(x => x.fromTimestamp === state.ride.fromTimestamp);
      return index < state.rides.length - 1;
    }
  }
};

const actions = {
  clear({ commit, state }) {
    if (state.fetching)
      return Promise.resolve();

    if (state.vehicel !== null || state.periodFrom !== null || state.periodTo !== null || state.ride !== null || state.locations !== null) {
      commit("fetched", {
        vehicle: null,
        periodFrom: null,
        periodTo: null,
        rides: null,
        ride: null,
        locations: null
      });
    }
  },

  fetchFile({ state }, params) {
    axios({
      url: `/v1/{#company#}/report/logbook/${state.vehicle.vehicleId}?from=${encodeURIComponent(DateTime.fromISO(state.periodFrom).toFormat(utils.API_DTFORMAT))}&to=${encodeURIComponent(DateTime.fromISO(state.periodTo).toFormat(utils.API_DTFORMAT))}`,
      headers: {
        "Accept": params.mimetype,
        "Accept-Language": "cs"
      },
      method: "GET",
      responseType: "blob" // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", state.vehicle.numericPlate + "." + params.ext);
      document.body.appendChild(link);
      link.click();
    });
  },

  refresh({ state, dispatch }) {
    if (state.query !== null) {
      state.query["refresh"] = true;
      dispatch("fetch", state.query);
    }
  },

  /**
   * Stáhní knihu jízd vodila podle zadaných parametrů.
   * Parametry: {
   *   vehicle: string,     - objekt vozidla
   *   periodFrom: string,  - datum a čas od
   *   periodTo: string,    - datum a čas do
   *   rideFrom: string     - vybrat jízdu (datum a čas)
   *  }
   *
   * @param params Parametry
   */
  fetch({ commit, state, dispatch }, params) {
    // pokud se vozidla právě vyčítaji, nic nedělěj
    if (state.fetching)
      return Promise.resolve();

    // nastavime, ze se objekt s touto URL uz stahuje, aby se to neptalo nekolikrat
    commit("fetching");

    try {
      if (params.vehicle === null || params.vehicle === undefined) {
        if (state.vehicle !== null)
          // pokud není vozidlo zadáno použij stávající (ale pouze pokud je zadáno)
          params.vehicle = state.vehicle;
        else {
          commit("fetched", {});
          return Promise.resolve();
        }
      }

      var change = (state.vehicle === null || state.vehicle === undefined || state.vehicle.vehicleId !== params.vehicle.vehicleId || params.refresh);
      var rides = null;
      var locations = null;
      //var ride_from = null;
      var ride = null;
      let tid;

      // zavolame stazeni objektu, ktere az se provede, tak se objekt ulozi
      return dispatch("progress/add", "Fetch record", { root: true })
        .then(id => {
          tid = id;
          // načti jízdy pouze pokud se změnilo období
          if (change || state.periodFrom == null || state.periodFrom !== params.periodFrom
            || state.periodTo == null || state.periodTo !== params.periodTo) {
            change = true;

            // nacti jizdy
            return axios.get(`/v1/{#company#}/vehicle/${params.vehicle.vehicleId}/ride?from=${encodeURIComponent(params.periodFrom)}&to=${encodeURIComponent(params.periodTo)}&size=2000`)
              .then((response) => {
                rides = response.data.content;
                return Promise.resolve();
              }).catch((error) => {
                commit("fetched", {});
                console.log("Vehicle rides fetch error", error);
                return undefined;
              });
          } else {
            rides = state.rides;
            return Promise.resolve();
          }
        })
        .then(() => {
          if (rides.length === 0) {
            // pokud neexistují žádné jízdy, nepokračuj a ulož stav
            return Promise.resolve();
          } else if (change || state.ride === null || state.ride.fromTimestamp !== params.rideFrom) {
            // načti pozice jízdy pokud:
            // 1. změna období
            // 2. není vyplněná jízda
            // 3. je vybrana jina jízda

            // najdi jízdu
            var fride = rides.filter(x => x.fromTimestamp === params.rideFrom);
            if (fride.length > 0)
              ride = fride[0];

            if (ride !== null) {
              return axios.get(`/v1/{#company#}/vehicle/${params.vehicle.vehicleId}/ride/${encodeURIComponent(DateTime.fromISO(ride.fromTimestamp).toISO())}/locations?size=2000`)
                .then((response) => {
                  locations = response.data.content;
                  return Promise.resolve();
                }).catch((error) => {
                  commit("fetched", {});
                  console.log("Vehicle rides fetch error", error);
                  return undefined;
                });
            } else {
              return Promise.resolve();
            }
          }
        })
        .then(() => {
          commit("fetched", {
            query: params,
            vehicle: params.vehicle,
            periodFrom: params.periodFrom,
            periodTo: params.periodTo,
            rides: rides,
            locations: locations,
            ride: ride
          });

          // zruš předchozí mód
          this.dispatch("online/mapMode", "logbook");

          return Promise.resolve();
        })
        .catch(() => {
          console.log("Fetch error");
        })
        .finally(() => {
          commit("finished");
          dispatch("progress/remove", tid, { root: true })
        });
    } catch {
      commit("finished");
      return Promise.resolve();
    }
  }
};

const mutations = {
  fetched(state, params) {
    Vue.set(state, "query", params.query || null);
    Vue.set(state, "vehicle", params.vehicle || null);
    Vue.set(state, "periodFrom", params.periodFrom || null);
    Vue.set(state, "periodTo", params.periodTo || null);
    Vue.set(state, "rides", params.rides || null);
    Vue.set(state, "ride", params.ride || null);
    Vue.set(state, "locations", params.locations || null);
  },

  rideChanged(state, params) {
    Vue.set(state, "ride", params.ride);
  },

  /**
   * Nastaví začátek stahování
   */
  fetching(state) {
    Vue.set(state, "fetching", true);
  },

  finished(state) {
    Vue.set(state, "fetching", false);
    Vue.set(state, "fetched", DateTime.now());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};